// hooks/usePage.js
import router from "@/router";
import { cloneDeep } from "lodash";
import { useUserStore } from "@/store";
import { appAuth } from "@/utils/auth.js";
import { checkApp, isWeixin } from "@/utils/common";
/**
 * 重定向
 * @param path 路径
 */
export function redirectTo(path) {
  const { replace } = router;
  replace(path);
}

/**
 * 路由带参跳转
 * @param {*} obj 路由的对象
 */
export function redirectPush(obj) {
  console.log(router);
  const { push } = router;
  push(obj);
}

/**
 * 返回上一页
 */
export function back() {
  router.back();
}

/**
 * 获取路由上query参数
 */
export function getRouteQuery() {
  const { currentRoute } = router;
  const { query } = currentRoute.value;
  return cloneDeep(query);
}

/**
 * 授权
 */
export async function goAuth(silent = true, obj) {
  if (isWeixin()) {
    //微信内部 需要手动授权
    const { currentRoute } = router;
    const { fullPath } = currentRoute.value;
    console.log(fullPath)
    useUserStore().setLandPage(fullPath);
    // 同时保存到 localStorage 防止状态丢失
    window.localStorage.setItem('authRedirect', fullPath);
    redirectPush({ name: "Auth" });
    return;
  }
  if (!checkApp()) {
    return;
  }
  if (silent) {
    try {
      const { push, currentRoute } = router;

      // 使用 Promise 版本确保异步操作完成
      const token = await appAuth({ showLoading: true });
      // 执行跳转
      if (obj) {
        redirectPush(obj);
      } else {
        // 如果没有指定跳转路径，刷新当前页面
        window.location.reload();
      }
    } catch (error) {
      console.error("授权或跳转失败:", error);
      // 可以添加错误处理逻辑
    }
  } else {
    const { currentRoute } = router;
    const { fullPath } = currentRoute.value;
    useUserStore().setLandPage(fullPath);
    redirectPush({ name: "Auth" });
  }
}
